<template>
  <v-snackbar v-model="snackbar.show" class="mb-6">
    {{ snackbar.nachricht }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" icon v-bind="attrs" @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    computed: {
      snackbar () { return this.$store.state.snackbar }
    },
    methods: {
      close () {
        this.$store.state.snackbar.show = false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// snackbar.vue?1eba5d08